import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_mobile-footer_desktopapp_store_badge_hover-action_unknown';

/**
 * Event when user hovers on app store download badge
 */
export function trackRetailerMobileFooterDesktopappStoreBadgeHover(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
